<template>
    <div class="pushes">        
        <v-dialog v-model="dialog" width="640">
            <template v-slot:activator="{ on }">
                <v-icon v-on="on">notifications</v-icon>
            </template>
            <div class="relative pushes-body">
                <div class="close pointer" @click="dialog = false">X</div>
                <div class="scroll">
                    <v-card>
                        <v-expansion-panels>
                            <v-expansion-panel class="panel" v-for="(push, i) in item.pushes" :key="i">
                                <Push :notice="item" :item="push"/>
                            </v-expansion-panel>
                        </v-expansion-panels>
                        <v-btn class="plus_button" text @click="add">Add</v-btn>
                    </v-card>
                </div>
            </div>
        </v-dialog>         
    </div>    
</template>

<script>
		import {mapActions, mapGetters} from 'vuex'
	import Push from './Push'
    export default {
        name: 'Pushes',
        components: {
            Push,	
        },
        props: ['item'],
        data() {
            return {
                dialog: false,
            }
        },
        computed:{
            ...mapGetters(['current_feed']),

        },
        methods: {
            ...mapActions(['addNoticePush', 'subscribe']),
			add(){
                const feed_id = this.current_feed._id
                const notice_id = this.item._id
                const data = {
                    body:  "",
                    time:  [],
                }
                this.addNoticePush({feed_id, notice_id, data})
                const subscribe = this.subscribe
                navigator.serviceWorker.ready.then(async function(reg) {
                    const sub = await reg.pushManager.getSubscription()                    
                    if (sub === null) {
                        const push = await reg.pushManager.subscribe({
                            userVisibleOnly: true,
                            applicationServerKey: 'BKzE-92O_ZicFbQsZ_O_6-3LFgiIa8hwjlTyeh-BQ8ptzRbNfNTVhbHi5jfpY0abDBFHtAOIVZhESTuuJndhQSY',
                        })
                        subscribe(push)
                        // document.body.append(JSON.stringify(push))
                        // console.log(JSON.stringify(push))
                    } else {
                        await sub.unsubscribe()
                        const push = await reg.pushManager.subscribe({
                            userVisibleOnly: true,
                            applicationServerKey: 'BKzE-92O_ZicFbQsZ_O_6-3LFgiIa8hwjlTyeh-BQ8ptzRbNfNTVhbHi5jfpY0abDBFHtAOIVZhESTuuJndhQSY',
                        })
                        subscribe(push)  
                        // We have a subscription, update the database
                        // console.log('Subscription object: ', sub);
                    }
                })                
			},
        },
        created(){

        }
}
</script>

<style lang="scss" scoped>
	.scroll{
		overflow-y: scroll;
        max-height: 90vh;
	}
    .pushes-body{
        font-family: 'Rambla', sans-serif;
    }
	.close{
        width: 60px;
        height: 60px;
        border-radius: 60px;
        background: #85de7b;
        color: #333;
        font-size: 22px;
        line-height: 60px;
        position: absolute;
        right: 10px;
        top: 10px;
        z-index: 2;
        text-align: center;
	}

</style>